@let currentNode = $currentNode();
@let currentNodeForm = $currentNodeForm();
@let currentFormSubmission = $currentFormSubmission();
@let isDesktop = deviceService.isDesktop$ | async;

@if ($isFinalPage()) {
  <x-workflow-header
    [isWelcomeStep]="false"
    [currentWorkflowTitle]="'workflows.final_page_header' | translate"
    [currentWorkflowSubTitle]="currentNode?.title || ''"
    [returnLink]="$returnLink()"
    [baseRoute]="$baseRoute()"
  />
  <x-workflow-screen-state
    [state]="$screenState()"
    [pendingWork]="$pendingWork()"
    [showBlockingStates]="false"
    (retry)="retryFailedSync()"
  />
  <x-workflow-final-page
    (syncData)="syncFinalPage()"
    [baseRoute]="$baseRoute()"
  />
} @else {
  @if (currentNodeForm) {
    <!-- Header (всегда сверху) -->
    <x-workflow-header
      [isWelcomeStep]="false"
      [currentWorkflowTitle]="$currentWorkflowName()"
      [currentWorkflowSubTitle]="currentNode?.title || ''"
      [returnLink]="$returnLink()"
      [baseRoute]="$baseRoute()"
    />

    <x-workflow-screen-state
      [state]="$screenState()"
      [pendingWork]="$pendingWork()"
      [showBlockingStates]="false"
      (retry)="retryFailedSync()"
    />
    <!-- Desktop Layout: Stepper слева, форма справа -->
    @if (isDesktop) {
      <div class="desktop-content-wrapper">
        <!-- Левая колонка: Stepper -->
        <tui-scrollbar class="x-white-secondary">
          <aside>
            <x-workflow-stepper [baseRoute]="$baseRoute()" class="p-10" />
          </aside>
        </tui-scrollbar>

        <!-- Правая колонка: Button (опционально) + Form -->
        <div class="form-column">
          <!-- Кнопка завершения регламентов (опциональная) -->
          @if ($allFormsCompleted()) {
            <div class="p-4 bg-green-50 border border-green-200 rounded-lg">
              <div class="flex items-center gap-3 mb-3">
                <span class="text-2xl">✅</span>
                <div>
                  <h3 class="x-font-body-2-bold x-text-dark-main">
                    {{ 'workflows.all_forms_completed' | translate }}
                  </h3>
                  <p class="x-font-body-4 x-text-dark-75 mt-1">
                    {{ 'workflows.you_can_submit_workflows' | translate }}
                  </p>
                </div>
              </div>
              <button
                tuiButton
                type="button"
                size="m"
                appearance="primary"
                (click)="goToFinalPage()"
              >
                {{ 'workflows.final_page_sync' | translate }}
              </button>
            </div>
          }

          <!-- Форма -->
          <x-workflow-node-form
            (syncData)="sync()"
            [formData]="currentNodeForm"
            [formSubmission]="currentFormSubmission"
            [request]="$request()"
            [workflowId]="workflowId()"
            [nodeId]="$currentNodeId()"
            [workflowIsCompleted]="$currentWorkflow()?.state === 'completed'"
          />
        </div>
      </div>
    } @else {
      <!-- Mobile Layout: стандартная вертикальная раскладка -->

      <!-- Кнопка завершения регламентов (опциональная) -->
      @if ($allFormsCompleted()) {
        <div class="p-4 bg-green-50 border border-green-200 rounded-lg">
          <div class="flex items-center gap-3 mb-3">
            <span class="text-2xl">✅</span>
            <div>
              <h3 class="x-font-body-2-bold x-text-dark-main">
                {{ 'workflows.all_forms_completed' | translate }}
              </h3>
              <p class="x-font-body-4 x-text-dark-75 mt-1">
                {{ 'workflows.you_can_submit_workflows' | translate }}
              </p>
            </div>
          </div>
          <button
            tuiButton
            type="button"
            size="m"
            class="w-full"
            appearance="primary"
            (click)="goToFinalPage()"
          >
            {{ 'workflows.final_page_sync' | translate }}
          </button>
        </div>
      }

      <!-- Форма -->
      <x-workflow-node-form
        (syncData)="sync()"
        [formData]="currentNodeForm"
        [formSubmission]="currentFormSubmission"
        [request]="$request()"
        [workflowId]="workflowId()"
        [nodeId]="$currentNodeId()"
        [workflowIsCompleted]="$currentWorkflow()?.state === 'completed'"
      />
    }
  }
}
